import React, { Component } from 'react';
import ManageCalendar from '../../pages/ManageCalendar';
import Layout from '../../components/Layout';
import Loading from '../../components/Base/Loading'
import { withFirebase } from "../../components/Firebase";
import { withRouter } from "react-router";

class ManageCalendarContainer extends Component {
	render() {
		const { profile } = this.props;
		return (
			<Layout {...this.props}>
				{profile == null
					? <Loading />
					: <ManageCalendar {...this.props} />	
				}
			</Layout>
		);
	}
}
 
export default withFirebase(withRouter(ManageCalendarContainer));